export default {
  title: 'Importer le menu',
  master_title: 'Mode marque - Import du menu',
  buttons: {
    import: 'Importer',
  },
  toasts: {
    import: {
      pending:
        "⏳L'importation peut parfois être lente, nous l'effectuons en arrière-plan. Veuillez vérifier le menu du restaurant dans quelques minutes.",
    },
  },
};
